import Auth from '../../modules/Authentication'
import { apiUrl } from '../../variables'
import { handleErrors, handleResponse } from '../../modules/Utils'

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}
const auth = new Auth()

export const RequisitionsApi = {
  list: () => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}requisitions/?select=_key,code,company,sales,title,owner,type,currency,converted,toBill,date,status`, {
      headers,
    })
      .then(handleErrors)
      .then(handleResponse)
  },
  vouchers: (key) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}requisitions/${key}/vouchers?select=*`, { headers }).then(handleErrors).then(handleResponse)
  },
  read: (key) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}requisitions/${key}?select=*`, { headers }).then(handleErrors).then(handleResponse)
  },
  create: (data) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}requisitions/`, {
      headers: headers,
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },

  importLines: (data) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}requisitions/importLines/`, {
      headers: headers,
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },
  update: (data) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}requisitions/`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },
  remove: (data) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}requisitions/`, {
      headers: headers,
      method: 'DELETE',
      body: JSON.stringify(data),
    }).then(handleErrors)
  },
  operation: (key, data) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}requisitions/${key}`, {
      headers,
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },

  lines: {
    list: (key) => {
      headers['authorization'] = `Bearer ${auth.getAccessToken()}`
      return fetch(`${apiUrl}requisitions/${key}/lines/`, { headers }).then(handleErrors).then(handleResponse)
    },
    create: (data) => {
      headers['authorization'] = `Bearer ${auth.getAccessToken()}`
      return fetch(`${apiUrl}requisitions/lines/`, {
        headers: headers,
        method: 'POST',
        body: JSON.stringify(data),
      })
        .then(handleErrors)
        .then(handleResponse)
    },
    update: (data) => {
      headers['authorization'] = `Bearer ${auth.getAccessToken()}`
      return fetch(`${apiUrl}requisitions/lines/`, {
        headers: headers,
        method: 'PATCH',
        body: JSON.stringify(data),
      })
        .then(handleErrors)
        .then(handleResponse)
    },
    remove: (data) => {
      headers['authorization'] = `Bearer ${auth.getAccessToken()}`
      return fetch(`${apiUrl}requisitions/lines/`, {
        headers: headers,
        method: 'DELETE',
        body: JSON.stringify(data),
      }).then(handleErrors)
    },
    removeBulk: (data) => {
      headers['authorization'] = `Bearer ${auth.getAccessToken()}`
      return fetch(`${apiUrl}requisitions/lines/bulk`, {
        headers: headers,
        method: 'DELETE',
        body: JSON.stringify(data),
      }).then(handleErrors)
    },
  },
}
